module.exports = __webpack_public_path__ + "img/bg-main.c800056b.svg";